import List from '@ecm/ui/element/List'

const HeroList = () => (
  <List
    items={['anywhere', 'anytime', 'any device']}
    icon="/images/icon/checkmark.svg"
    my="1.5em"
    display={{ sm: 'flex', xs: 'block' }}
    justifyContent="space-between"
    maxWidth="450px"
    sx={{
      '& li': {
        fontWeight: 700,
        mb: { sm: 0, xs: '1em' },
        whiteSpace: 'nowrap',
      },
      '& li:before': {
        height: '32px',
        left: '-40px',
        opacity: 0.7,
        width: '32px',
      },
    }}
  />
)

export default HeroList
